import { mapCustomizationGroup } from '~/composables/mapCustomizationGroup'
import { type DietaryOptionType, DietaryOptionTypeValues } from '~/enums'
import type { PublicStoreMenuItem } from '~/services/api/menus/public/useMenusPublicService'
import { Normalization } from '~/utils/normalization'

const parseBooleanFlag = (value: number): boolean => {
  if (value === 0) return false
  if (value === 1) return true
  throw new TypeError(`Expected a binary integer flag, received ${value}.`)
}
const parseDietaryOptionType = (value: string): DietaryOptionType => {
  const parsed = Normalization.enumValue(value, DietaryOptionTypeValues, null)
  if (parsed === null) {
    throw new TypeError(`Unsupported dietary option type: ${value}.`)
  }
  return parsed
}
export const mapPublicStoreMenuItem = (item: PublicStoreMenuItem) => ({
  calories_per_serving: item.calories_per_serving,
  created_at: item.created_at,
  customizations: item.customizations.map(mapCustomizationGroup),
  description: item.description,
  dietary_options: item.dietary_options.map((option) => ({
    id: option.id,
    name: option.name,
    slug: option.slug,
    type: parseDietaryOptionType(option.type)
  })),
  id: item.id,
  ...(item.image === null ? {} : { image: item.image }),
  individual_packaging_available: item.individual_packaging_available,
  is_featured: item.is_featured,
  is_new: parseBooleanFlag(item.is_new),
  is_popular: parseBooleanFlag(item.is_popular),
  is_special: parseBooleanFlag(item.is_special),
  name: item.name,
  order_count: item.order_count,
  popularity_score: item.popularity_score,
  preparation_time: item.preparation_time,
  price: String(item.price),
  price_type: item.price_type,
  serves_count: item.serves_count,
  sort_order: item.sort_order,
  updated_at: item.updated_at
})
